

(function(a,b){var c=function(a,b,c){var d;return function e(){function g(){if(!c)a.apply(e,f);d=null}var e=this,f=arguments;if(d)clearTimeout(d);else if(c)a.apply(e,f);d=setTimeout(g,b||20)}};jQuery.fn[b]=function(a){return a?this.bind("resize",c(a)):this.trigger(b)}})(jQuery,"smartresize")

var $masonry = $('.masonry');
var navigationTopOffset;
var navigationHeight;

jQuery(window).load(function(){
  
  

  
    

    $('#slider li img').click(function(){
      var url = jQuery(this).attr('data-url');
      if (url && url.length > 0) {
        window.open(url);
      }
    });

    $('#carousel li img').click(function(el){
      var url = jQuery(this).attr('data-url');
      if (url && url.length > 0) {
        window.open(url);
      }
    });
  

  
  var IE6 = false /*@cc_on || @_jscript_version < 5.7 @*/;
  if(IE6){
    if($("#placeholder img").width() > 360){
      $("#placeholder img").css('width', '360px');
    } else {
      $("#placeholder img").css('width', $("#placeholder img").width()+'px'); // restrict to initial width of image
    }
  } else {
    //$("#placeholder img").css('maxWidth', $("#placeholder img").width()+'px'); // restrict to initial width of image
  }

  var pw = $("#placeholder img").width() + 8;
  //$("#placeholder img").parents('div.featured').css('maxWidth', pw+'px'); // force IE to play nice
  
});

jQuery(document).ready(function($){

  var mobileNav = $('.mobile-nav:visible'),
      mobileNavHeight = mobileNav.outerHeight() || 0,
      lastScrollTop = 0,
      scrollTopRan = false,
      $wrapper = $('.wrapper:first');

  $(window).scroll(function (e) {
    var st = $(window).scrollTop();
    if (mobileNav.has('.clearfix.active').length > 0) {
      mobileNav.css('top', 0);
      $wrapper.css('padding-top', mobileNavHeight);
      return;
    }
    if (st <= mobileNavHeight) {
      if (!(st < 0)) {
        mobileNav.css('top', st * -1);
      }
      return;
    }
    if (lastScrollTop > st || st < 0) {
      mobileNav.css('top', 0);
    } else if (lastScrollTop < st) {
      mobileNav.css('top', mobileNavHeight * -1);
    }
    if (st < 0) { // account for mobile negative scrollTop
      lastScrollTop = 0;
    } else {
      lastScrollTop = st;
    }
  });

  var indexImgPath = "//www.belowtheboat.com/cdn/shop/t/26/assets/holding-the-chart.jpg?v=68981741607595026081762509635",
      indexImg = $('<img src="' + indexImgPath + '" class="index-img" />');

  indexImg.load(function(){
    $('#index .banner').css('left', 0);
    $('.mobile-title').css('opacity', 1);
  }).insertAfter('#index .mobile-title');

  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#ffffff',
    overlayOpacity: 0.5
  });

  function mobileNavMenuBind () {
    var mobileNav = $('.mobile-nav'),
        menuBtn = $('.mobile-nav .menu-btn'),
        menuHeadings = $('.mobile-nav .clearfix>li>a');
    menuBtn.off('click');
    menuHeadings.off('click');
    if (mobileNav.is(':visible')) {
      menuBtn.on('click', function (e) {
        e.preventDefault();
        $('.mobile-nav ul.clearfix, .mobile-nav .menu-btn i').toggleClass('active');
        return false;
      });
      menuHeadings.on('click', function (e) {
        if ($(this).attr('href') === '') {
          e.preventDefault();
          $(this).parent('li').toggleClass('active');
          return false;
        } else {
          return true;
        }
      });
    }
    if (mobileNav.is(':visible') == 0) {
      $wrapper.css('padding-top', 0);
    }
  }
  $(window).resize(mobileNavMenuBind).resize();


  

  $(".product-masonry .masonry-item .image img, .products.masonry .masonry-item .image img").unveil(300, function() {
    
  });

  $(window).resize(function () {
    
  });

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $("section.mobile-nav select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });

  $('#product .add-to-cart').click(function(e){
    $('#add-item-to-cart').click();
  });



  

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })

  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });

  //loop through home page customer quotes
  var quotes = $(".quotes");
        	var quoteIndex = -1;

  function showNextQuote() {
    if ($('.quote-wrap').is(':visible')) {
      ++quoteIndex;
      var quote = quotes.eq(quoteIndex % quotes.length);
      quotes.not(quoteIndex % quotes.length).hide();
      quote.fadeIn(600)
        .delay(5000)
        .fadeOut(800, showNextQuote);
    } else {
      setTimeout(showNextQuote, 6400);
    }
  }
  showNextQuote();

}); // end document ready

if ((typeof Shopify) === 'undefined') { Shopify = {}; }
Shopify.money_format = '$';

function remove_item(id) {
  document.getElementById('updates_'+id).value = 0;
  document.getElementById('cartform').submit();
}

var selectCallback = function(variant, selector) {
  if (variant && variant.available == true) {
    jQuery('#add-to-cart').removeAttr('disabled'); // remove unavailable class from add-to-cart button, and re-enable button
    if(variant.price < variant.compare_at_price){
      jQuery('#price-preview').html(Shopify.formatMoney(variant.price, "").replace('.00', '') + " <del>" + Shopify.formatMoney(variant.compare_at_price, "").replace('.00', '') + "</del>");
    } else {
      jQuery('#price-preview').html(Shopify.formatMoney(variant.price, "").replace('.00', ''));
    }
  } else { // variant does not exist
    jQuery('#add-to-cart').attr('disabled', 'disabled'); // set add-to-cart button to unavailable class and disable button
    var message = variant ? "Sold Out" : "Unavailable";
    jQuery('#price-preview').text(message);
  }
};
if (typeof(Galleria) !== 'undefined') {
  Galleria.loadTheme('galleria/themes/classic/galleria.classic.min.js');
  Galleria.run('#galleria');
}
